/**
 * @flow
 * @relayHash 7b52ae08657b3b0d8c8458ffe47e3e78
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Clip_viewer$ref = any;
export type ClipLoaderQueryVariables = {||};
export type ClipLoaderQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Clip_viewer$ref
  |}
|};
export type ClipLoaderQuery = {|
  variables: ClipLoaderQueryVariables,
  response: ClipLoaderQueryResponse,
|};
*/


/*
query ClipLoaderQuery {
  viewer {
    ...Clip_viewer
    id
  }
}

fragment Clip_viewer on Viewer {
  id
  userId
  isInternalIp
  isLogin
  isBusiness
  isActiveBusinessCart
}
*/

const node/*: ConcreteRequest*/ = {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ClipLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Clip_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ClipLoaderQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "userId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isInternalIp",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isLogin",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isBusiness",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isActiveBusinessCart",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ClipLoaderQuery",
    "id": null,
    "text": "query ClipLoaderQuery {\n  viewer {\n    ...Clip_viewer\n    id\n  }\n}\n\nfragment Clip_viewer on Viewer {\n  id\n  userId\n  isInternalIp\n  isLogin\n  isBusiness\n  isActiveBusinessCart\n}\n",
    "metadata": {}
  }
};
// prettier-ignore
(node/*: any*/).hash = '88a6fd0cb826fb14f7653042a46e7ee3';
module.exports = node;
